import { render } from "./BaseError.vue?vue&type=template&id=a14e9838&scoped=true"
import script from "./BaseError.vue?vue&type=script&lang=js"
export * from "./BaseError.vue?vue&type=script&lang=js"

import "./BaseError.vue?vue&type=style&index=0&id=a14e9838&lang=scss&scoped=true"

import exportComponent from "C:\\projects\\balkan-app-links\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a14e9838"]])

export default __exports__